(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.BoCodRequest = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var TRANSIENT_STATUSES = [502, 503, 504];
  var HONEYPOT_SELECTOR = 'input[name="bo_hp"], input[name="website"]';

  // El autofill de navegadores in-app (TikTok) y de Chrome puede rellenar el
  // honeypot sin tecleo real; solo un keydown confiable (isTrusted) marca el
  // campo como escrito de verdad. Sin esa marca, el valor se envia vacio.
  if (typeof document !== 'undefined' && document.addEventListener) {
    document.addEventListener('keydown', function (event) {
      var target = event && event.isTrusted === true ? event.target : null;
      if (target && target.matches && target.matches(HONEYPOT_SELECTOR)) {
        target.setAttribute('data-bo-hp-keyed', '1');
      }
    }, true);
  }

  function sanitizeHoneypot(payload) {
    var value = payload && payload.website != null ? String(payload.website) : '';
    if (!value.trim() || typeof document === 'undefined') return payload;
    var fields = document.querySelectorAll(HONEYPOT_SELECTOR);
    if (!fields.length) return payload;
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].getAttribute('data-bo-hp-keyed') === '1') return payload;
    }
    var clean = {};
    for (var key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) clean[key] = payload[key];
    }
    clean.website = '';
    clean.hpAutofill = 1;
    return clean;
  }

  async function submit(options) {
    options = options || {};
    var endpoint = String(options.endpoint || '');
    var fetchImpl = options.fetchImpl || fetch;
    var timeoutMs = positiveNumber(options.timeoutMs, 15000);
    var onState = typeof options.onState === 'function' ? options.onState : function () {};
    var body = JSON.stringify(sanitizeHoneypot(options.payload || {}));
    var transientRetries = 0;
    var progressPolls = 0;
    var attempt = 0;

    if (!endpoint) throw publicError('missing_endpoint', 0, false, 0);

    while (true) {
      attempt += 1;
      onState({ name: 'submitting', attempt: attempt });

      var response;
      try {
        response = await fetchWithTimeout(fetchImpl, endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
        }, timeoutMs);
      } catch (error) {
        if (transientRetries < 1) {
          transientRetries += 1;
          onState({ name: 'retrying', attempt: attempt, code: error && error.name === 'AbortError' ? 'timeout' : 'network_error' });
          continue;
        }
        throw publicError(error && error.name === 'AbortError' ? 'timeout' : 'network_error', 0, true, 0);
      }

      var data = await parseJsonResponse(response);
      if (response.ok && data && data.ok) return data;

      var code = String(data && data.error || 'order_failed');
      var retryAfter = parseRetryAfter(response.headers && response.headers.get('Retry-After'));

      if (response.status === 409 && code === 'request_in_progress' && progressPolls < 3) {
        progressPolls += 1;
        onState({ name: 'verifying', attempt: attempt, code: code, retryAfter: retryAfter });
        await wait(retryAfter * 1000);
        continue;
      }

      if (response.status === 429) {
        onState({ name: 'rate_limited', attempt: attempt, code: code, retryAfter: retryAfter });
        throw publicError(code, response.status, true, retryAfter);
      }

      if (TRANSIENT_STATUSES.indexOf(response.status) !== -1 && transientRetries < 1) {
        transientRetries += 1;
        onState({ name: 'retrying', attempt: attempt, code: code, retryAfter: retryAfter });
        await wait(retryAfter * 1000);
        continue;
      }

      throw publicError(code, response.status, response.status >= 500 || code === 'request_in_progress', retryAfter);
    }
  }

  async function fetchWithTimeout(fetchImpl, url, init, timeoutMs) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, timeoutMs);
    try {
      return await fetchImpl(url, Object.assign({}, init, { signal: controller.signal }));
    } finally {
      clearTimeout(timer);
    }
  }

  async function parseJsonResponse(response) {
    var text = await response.text();
    try {
      return JSON.parse(text);
    } catch (_) {
      throw publicError('invalid_response', response.status || 0, true, 0);
    }
  }

  function publicError(code, status, recoverable, retryAfter) {
    var error = new Error(code);
    error.name = 'BoCodRequestError';
    error.code = code;
    error.status = Number(status) || 0;
    error.recoverable = Boolean(recoverable);
    error.retryAfter = Number(retryAfter) || 0;
    return error;
  }

  function parseRetryAfter(value) {
    var seconds = Number.parseInt(value || '0', 10);
    return Number.isFinite(seconds) && seconds > 0 ? Math.min(seconds, 60) : 0;
  }

  function positiveNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function wait(ms) {
    return ms > 0 ? new Promise(function (resolve) { setTimeout(resolve, ms); }) : Promise.resolve();
  }

  return { submit: submit };
});
